<template>
  <b-container>
    <b-card>
      <b-form @submit="saveChanges">
        <b-row>
          <b-col sm="12">
            <b-form-group
              label="Communication"
              label-for="communication"
            >
              <b-form-input
                id="communication"
                v-model="communication"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <ModalAdditionalInfo key="communication" v-model="communicationAdditionalInfo" />
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Datacomm"
              label-for="datacomm"
            >
              <b-form-input
                id="datacomm"
                v-model="datacomm"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <ModalAdditionalInfo key="datacomm" v-model="datacommAdditionalInfo" />
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Internet"
              label-for="internet"
            >
              <b-form-input
                id="internet"
                v-model="internet"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <ModalAdditionalInfo key="internet" v-model="internetAdditionalInfo" />
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Wireless"
              label-for="wireless"
            >
              <b-form-input
                id="wireless"
                v-model="wireless"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <ModalAdditionalInfo key="wireless" v-model="wirelessAdditionalInfo" />
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Cyber Security"
              label-for="cyberSecurity"
            >
              <b-form-input
                id="cyberSecurity"
                v-model="cyberSecurity"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <ModalAdditionalInfo key="cyberSecurity" v-model="cyberSecurityAdditionalInfo" />
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Bundling"
              label-for="bundling"
            >
              <b-form-input
                id="bundling"
                v-model="bundling"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col sm="12">
            <ModalAdditionalInfo key="bundling" v-model="bundlingAdditionalInfo" />
          </b-col> -->
          <b-col sm="12">
            <b-form-group
              label="Ebis"
              label-for="ebis"
            >
              <b-form-input
                id="ebis"
                v-model="ebis"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Wins"
              label-for="wins"
            >
              <b-form-input
                id="wins"
                v-model="wins"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Cons"
              label-for="cons"
            >
              <b-form-input
                id="cons"
                v-model="cons"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="PCC"
              label-for="pcc"
            >
              <b-form-input
                id="pcc"
                v-model="pcc"
              />
            </b-form-group>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button
              type="submit"
              :disabled="isLoading"
              variant="primary"
            >
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import {
  BRow, BCol, BContainer, BFormGroup, BCard, BFormInput, BButton, BForm,
} from 'bootstrap-vue'

const ModalAdditionalInfo = () => import('./addtional-info.vue')

export default {
  components: {
    BRow, BCol, BContainer, BFormGroup, BCard, BFormInput, BButton, BForm,
    ModalAdditionalInfo
  },
  data() {
    return {
      isLoading: false,
      communication: '',
      communicationAdditionalInfo: {
        imageTree: null,
        video: null
      },
      datacomm: '',
      datacommAdditionalInfo: {
        imageTree: null,
        video: null
      },
      internet: '',
      internetAdditionalInfo: {
        imageTree: null,
        video: null
      },
      wireless: '',
      wirelessAdditionalInfo: {
        imageTree: null,
        video: null
      },
      cyberSecurity: '',
      cyberSecurityAdditionalInfo: {
        imageTree: null,
        video: null
      },
      bundling: '',
      bundlingAdditionalInfo: {
        imageTree: null,
        video: null
      },
      ebis: '',
      wins: '',
      cons: '',
      pcc: '',
    }
  },

  mounted() {
    this.fetchSettings()
  },

  methods: {
    fetchSettings() {
      this.$http.get('/settings/product')
        .then(res => {
          this.communication = res.data.data.communication
          this.communicationAdditionalInfo = {
            previous_imageTree: res.data.image_tree.communication,
            previous_video: res.data.video.communication
          }
          this.datacomm = res.data.data.datacomm
          this.datacommAdditionalInfo = {
            previous_imageTree: res.data.image_tree.datacomm,
            previous_video: res.data.video.datacomm
          }
          this.internet = res.data.data.internet
          this.internetAdditionalInfo = {
            previous_imageTree: res.data.image_tree.internet,
            previous_video: res.data.video.internet
          }
          this.wireless = res.data.data.wireless
          this.wirelessAdditionalInfo = {
            previous_imageTree: res.data.image_tree.wireless,
            previous_video: res.data.video.wireless
          }
          this.cyberSecurity = res.data.data.cyberSecurity
          this.cyberSecurityAdditionalInfo = {
            previous_imageTree: res.data.image_tree.cyberSecurity,
            previous_video: res.data.video.cyberSecurity
          }
          this.bundling = res.data.data.bundling
          this.bundlingAdditionalInfo = {
            previous_imageTree: res.data.image_tree.bundling,
            previous_video: res.data.video.bundling
          }
          this.ebis = res.data.data.ebis
          this.wins = res.data.data.wins
          this.cons = res.data.data.cons
          this.pcc = res.data.data.pcc
        })
        .catch(err => { this.$notif('Error', `${err.message}`, 'error') })
    },

    saveChanges(event) {
      event.preventDefault()
      this.isLoading = true
      let payload = {
        communication: this.communication,
        datacomm: this.datacomm,
        internet: this.internet,
        wireless: this.wireless,
        cyberSecurity: this.cyberSecurity,
        bundling: this.bundling,
        ebis: this.ebis,
        wins: this.wins,
        cons: this.cons,
        pcc: this.pcc
      }
      payload = this.mapAdditionalInfo(payload, this.communicationAdditionalInfo, 'communication')
      payload = this.mapAdditionalInfo(payload, this.datacommAdditionalInfo, 'datacomm')
      payload = this.mapAdditionalInfo(payload, this.internetAdditionalInfo, 'internet')
      payload = this.mapAdditionalInfo(payload, this.wirelessAdditionalInfo, 'wireless')
      payload = this.mapAdditionalInfo(payload, this.cyberSecurityAdditionalInfo, 'cyberSecurity')
      payload = this.mapAdditionalInfo(payload, this.bundlingAdditionalInfo, 'bundling')
      const fd = new FormData()
      Object.entries(payload).forEach(([key, val]) => {
        fd.append(key, val)
      })

      this.$http.post('/settings/product', fd )
        .then(() => {
          this.$notif('Success', 'Settings has been successfully updated.', 'success')
          this.fetchSettings()
        })
        .catch(err => { this.$notif('Error', `${err.message}`, 'error') })
        .finally(() => { this.isLoading = false })
    },
    mapAdditionalInfo(payload, additionalInfo, name) {
      const newPayload = { ...payload }
      Object.entries(additionalInfo).forEach(([key, value]) => {
        if (value) {
          newPayload[name + '_' + key] = value
        }
      })
      return newPayload
    }
  },
}
</script>
